import React, { useCallback, useEffect, useState } from "react";
import { Dimensions, ScrollView, StyleSheet, View, Text, Linking, Platform } from "react-native";
import Queries from "../../../api/queries";
import { HouseRules } from "../../../types/types";
import { MD3Theme, useTheme } from "react-native-paper";
import { mobUser } from "../../../mobx/MobUser";
import i18n from "../../../i18n";
import AppButton from "../../../components/AppButton";
import { useFocusEffect } from "@react-navigation/native";
import { SafeAreaView } from "react-native-safe-area-context";
import FooterDivider from "../../../components/FooterDivider";


export default function Rules() {
  const theme = useTheme();
  const styles = styleGen(theme);

  const [rulesData, setRulesData] = useState<HouseRules>({
    enLink: "",
    frLink: ""
  });

  const queries = new Queries();

  const fetchRules = async () => {
    try {
      let queryResult = await queries.getActiveHouseRules();

      if (queryResult) {
        setRulesData(queryResult.data.getActiveHouseRules);
      }
    } catch (err) {
      console.error("Error fetching house rules:", err);
    }
  }

  useFocusEffect(
    useCallback(() => {
      fetchRules();
    }, [])
  );

  return (
    <SafeAreaView style={{ flex: 1 }} edges={['bottom']}>
      <ScrollView contentContainerStyle={styles.container}>
        <View style={styles.subContainer}>
          <View>
            <Text style={styles.title}>
              {i18n.t("pages.rules.link")}
            </Text>
            <AppButton
              extraStyle={{ margin: 0 }}
              onPress={() => {
                const url = mobUser.Language === "fr" ? rulesData.frLink : rulesData.enLink;

                if (Platform.OS === "web") {
                  window.open(url, "_blank");
                } else {
                  Linking.openURL(url);
                }
              }}
            >
              {i18n.t("home.houseRules")}
            </AppButton>
          </View>
        </View>
        <FooterDivider />
      </ScrollView>
    </SafeAreaView>
  );
}

const styleGen = (theme: MD3Theme) => StyleSheet.create({
  container: {
    width: "100%",
    alignItems: "center",
  },
  subContainer: {
    borderColor: theme.colors.secondary,
    borderWidth: 3,
    width: "80%",
    borderRadius: 20,
    padding: 15,
    gap: 15,
    minHeight: 150,
    marginTop: 20
  },
  pdf: {
    flex: 1,
    width: Dimensions.get('window').width,
    height: Dimensions.get('window').height,
  },
  cardsList: {
    marginTop: 75,
    width: "100%",
    gap: 30
  },
  title: {
    fontSize: 20,
    padding: 3,
    fontFamily: "NotoSans-Bold",
    marginBottom: 20
  },
  text: {
    fontSize: 17,
    padding: 3,
  },
});
